<script>
import axios from 'axios'
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import { XIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  extends: BaseModal,
  components: { XIcon, CpuWireframe },
  data: function () {
    return {
      selectedCpu: null
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.selectedCpu = this.cp.units.filter((cpu) => {
      return _.map(cpu.boxes, 'id').indexOf(this.data.box.id) != -1
    })[0]
  },
  methods: {
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    },
    freeLocker() {
      this.$blockUI()
      axios({
        method: 'put',
        url: `boxes/${this.data.box.id}/free`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        }
      })
        .then((response) => {
          this.close(true)
        })
        .catch((error) => {
          this.$errorHumanized(error)
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="close()")
  .modal-body
    .row
      .col-9
        h1.page__header {{ $t('support.collectomate.supportCollectomateOpenLockerModal.header') }}
        h3.page__description.mb-5 {{ $t('support.collectomate.supportCollectomateOpenLockerModal.subheader') }}
      .col-3
        .cpu-thumbnails(v-if="cp && data.box.id && selectedCpu")
          cpu-wireframe(
            v-for="cpu in cp.units"
            :key="cpu.id"
            :cpu="cpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="80"
            :openedBoxId="data.box.id || ''"
            :isSelected="cpu.id == selectedCpu.id"
            :displayIcons="false"
          )
    .row
      .col-3.button-wrapper
        span {{ data.status }}
        template(
          v-if="data.box.status == 'service_required' || data.box.status == 'broken'"
        )
          button.btn.btn-primary.btn-block.text-white.mb-4(
            type="button"
            v-ea-click="freeLocker"
          ) {{ $t('support.collectomate.supportCollectomateOpenLockerModal.freeLockerButton') }}

      .col-4.offset-1
        .selected-cpu(v-if="cp && data.box.id && selectedCpu")
          cpu-wireframe(
            v-if="!!selectedCpu"
            :cpu="selectedCpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="300"
            :openedBoxId="data.box.id || ''"
            :isSelected="true"
          )
</template>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.cpu-thumbnails {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.selected-cpu {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
